import Http from "../common/request";

export const getUserInfo = () => {
    return Http.get('/user/api/login/base/queryUserInfo', {
        _auth: true,
        _silent: true,
        queryAccount: 1,
        queryIm: 1,
        querySubscribe: 0
    })
}

export const queryDiamondOrderStatus = (orderId: string) => {
    return Http.get('/user/api/pay/recharge/findRechargeOrderById', { _auth: true, _silent: true, orderId })
}
